import { useAtomValue } from 'jotai';
import { customersQueryAtom, buildQueryKey } from '../../../../states/customers';
import { advisorsQueryAtom, buildAdvisorsQueryKey } from '../../../../states/advisors';
import { useMemo } from 'react';

const useAutoCompleteOptions = () => {
  const { customers } = useAtomValue(customersQueryAtom(buildQueryKey({})));
  const { advisors } = useAtomValue(advisorsQueryAtom(buildAdvisorsQueryKey({})));

  const customerOptions = useMemo(
    () =>
      Array.from(new Set(customers.map(c => c.name))).map(c => {
        return { value: c };
      }),
    [customers]
  );
  const advisorOptions = useMemo(
    () =>
      Array.from(new Set(advisors.map(a => a.name))).map(a => {
        return { value: a };
      }),
    [advisors]
  );

  return { customerOptions, advisorOptions };
};

export default useAutoCompleteOptions;
